export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

const map = {
  dev: {
    PCZHONGHESCHOOL: 'https://dm.zhongheschool.com',      //    众合开发环境
    PCZHUMAVIP: 'https://dm.zhumavip.com'               //    竹马开发环境
  },
  test: {
    PCZHONGHESCHOOL: 'https://tm.zhongheschool.com',
    PCZHUMAVIP: 'https://tm.zhumavip.com'
  },
  uat: {
    PCZHONGHESCHOOL: 'https://um.zhongheschool.com',
    PCZHUMAVIP: 'https://um.zhumavip.com'
  },
  pro: {
    PCZHONGHESCHOOL: 'https://m.zhongheschool.com',
    PCZHUMAVIP: 'https://m.zhumavip.com'
  }

}

function isJump(arr, pathname) {
  for (let i = 0; i < arr.length; i++) {
    if (pathname.includes(arr[i])) {
      return true
    }
  }

  return false
}

const jumpList = [
  'fakao/caption/eul',
  'fashuo/caption/eul',
  'fakao/activity/mockexam',
  'fashuo/activity/mockexam',
  'fakao/activity/2023promotion',
  'fashuo/activity/2023promotion',
  'html/aboutus.html',
  'html/aboutusSchool.html',
  'mall/order/create',
  'userReport/share_beisong.html',
  'userReport/share_index.html',
  'userReport/share_kind.html',
  'activity/618promotion',
  'nationwideDistribution/can_cashDetailedList',
  'nationwideDistribution/cashDetailedList',
  'nationwideDistribution/cashRecord',
  'nationwideDistribution/revenueRecord',
  'nationwideDistribution/newDistribution_rankingList',
  'nationwideDistribution/rule',
  'nationwideDistribution/newDistribution',
  'nationwideDistribution/center',
  'nationwideDistribution/modifyAmount',
  'nationwideDistribution/sharePosters',
  'nationwideDistribution/cashRequest',
  'wp/my',
  'wp/bookup',
  'wp/upgrade',
  'wp/successPage',
  'wp/applyrecord',
  'wp/applyforrefund',
  'wp/processdecribe',
  'wp/findorderid',
  'wp/applidetail',
  'wp/band',
  'wp/result',
  'wp/userInfo20',
  'activity/510plan',
  'caption/mxDataReport',
  'activity/answer-placement',
  'mall/conventioncourse-child',
  'mall/conventioncourse',
  'w/points',
  'my/myModifyAddress',
  'mall/order',
  'paySuccess',
  'points/explain',
  'points/modify',
  'points/address',
  'points/payresult',
  'points/pay',
  'points/detail',
  'points/product',
  'points/exchange',
  'points/task',
  'fakao/points',
  'fashuo/points',
  'activity/2023-new-user',
  'my/myAddress',
  'my/mySubmitAddress',
  'mall/orderBind',
  'activity/school-open',
  'my/studyPlanReport',
  'my/studyPlan',
  'wp/salesman/signup',
  'wp/appointment',
  'wp/salesman/prepaidOrders',
  'wp/salesman/paidOrders',
  'wp/fxproduct',
  'wp/fxproducts',
  'activity/no-closing',
  'activity/annual-report',
  'activity/new-year-goods',
  'bookerrata',
  'fiveAnniversary/promotion',
  'activity/fiveAnniversary/index',
  'caption/new-shop-tripe',
  'caption/new-shop-update',
  'caption/delivery-modify2',
  'caption/delivery-notice2',
  'caption/delivery-modify',
  'caption/delivery-notice',
  'rich-text',
  'activity/20221212/index',
  'activity/20221111/venueIndex',
  'activity/20221111/collecting',
  'activity/20221111/conversion',
  'activity/20221111/share',
  'my/refundRecord',
  'my/applyRefund',
  'applicationDetails',
  'logisticsDetail',
  'logisticsList',
  'my/returnGoodsStep',
  'my/refundDetail',
  'fakao/open',
  'fashuo/open',
  'fakao/wangshou',
  'fashuo/wangshou',
  'fakao/mianshou',
  'fashuo/mianshou',
  'fakao/live',
  'fashuo/live',
  'fakao/book',
  'fashuo/book',
  'fakao/recommend',
  'fashuo/recommend',
  'my/orders',
  'activity/prepare2023',
  'butRefund',
  '/login',
  'activity/exam-signup',
  'ossCoupon',
  'activity/fakao',
  'activity/fashuo',
  'rankingList',
  'my/levelinfo',
  'question-group/answer',
  'activity/coupon-bag',
  'fakao/my',
  'fashuo/my',
  'x/my',
  'share/note',
  'shiwu',
  'w/downloadpc',
  'download',
  'wp/entrance20',
  // 'activity/code',
  '/w/fvhuibian' // 法律法规汇编
]


const SEM_URLS = [
  '/page/pcsem/activitySem3.html',
  '/page/pcsem',
  '/pc/sempc.html',
  '/pc/sempcxin.html',
  '/page/pcsem/wsempcxin/yanzheng.html',
  '/page/pcsem/wsempcxin.html',
  '/page/pcsem/txssppxin.html',
  '/page/pcsem/360ppxin.html',
  '/page/pcsem/fashuo/px/yanzheng.html',
  '/page/pcsem/fashuo/px.html',
  '/page/pcsem/fashuo/pp/yanzheng.html',
  '/page/pcsem/fashuo/pp.html',
  '/page/pcsem/bmzc.html',
  '/page/pcsem/txssbmzc.html',
  '/page/pcsem/bmzc/yanzheng.html',
  '/page/pcsem/fashuo/bmzc.html',
  '/page/pcsem/fashuo/bmzc/yanzheng.html',
  '/fakao/pcsem/px.html',
  '/fakao/pcsem/px.html',
  '/fakao/pcsem/px.html',
  '/page/pcsem/px.html',
  '/page/pcsem/txsspx.html',
  '/page/pcsem/360px.html',
  '/page/pcsem/px/yanzheng.html',
  '/fakao/mall/recruit/home',
  '/fashuo/mall/recruit/home',
]
if (isMobileDevice()) {
  const { host, search = '', pathname } = window.location
  const urls = map[process.env.ENVIRONMENT]
  if (host.includes('zhongheschool.com')) {
    if (SEM_URLS.includes(pathname) || pathname.includes('/activity/code')) {
      console.log('不跳转')
    } else {
      window.location.replace(`${urls.PCZHONGHESCHOOL}${pathname}${search}`)
    }
  }
  if (host.includes('zhuma')) {
    let jumpResult = isJump(jumpList, pathname)

    console.log(jumpResult, '--jumpResult--')
    if (jumpResult) {
      window.location.replace(`${urls.PCZHUMAVIP}${pathname}${search}`)
    }
  }
}
